var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 375 816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 187.5,
    y1: 816,
    x2: 187.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0be3cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#12beb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1a9a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#207a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#256172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#294e64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2c405b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2e3855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f3654"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 375,
    height: 816
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundApp);
export default __webpack_public_path__ + "static/media/background_app.715441d611a06936f6e5fc7c75cbbb54.svg";
export { ForwardRef as ReactComponent };